import { Link } from "react-router-dom";

const Layout = (props) => {
  const { file, name } = props
  return (
    <div className=" min-h-screen text-[#2BBACA]">
      <header
        className={`sticky top-0 py-4 bg-[#2BBACA] text-center px-4 md:px-6 text-white text-2xl shadow-xl`}
      >
        <Link to="/" className="drop-shadow-2xl hover:text-gray-200">Kambing Cup</Link> {name && `- ${name}`} 
      </header>
      <div
        style={{backgroundImage: `url(${file})`}}
        className={`bg-top bg-cover max-w-full overflow-auto screen-calc`}
      >
        {props.children}
      </div>
    </div>
  );
};

export default Layout;
